module.exports = __webpack_public_path__ + "static/media/popina_thumb_even.8b2812c4.jpg";